import React from 'react';
import { Link } from "react-router-dom";
import LightDarkSwitch from './LightDarkSwitch';

export default function Navbar() {
  return (
    <nav>
        <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/contact">Contact</Link></li>
        </ul>
	  </nav>
  )
}